/**
 * The instructor a learner page is for: the public id in `/a/<id>` (the photo-real 서재형 담쌤 is
 * reached that way beside the animated one at `/`, 2026-09-29), or null for the default classroom.
 */
import { profileIdForHost } from "../profile-host";

export function learnerProfileId(
  pathname = typeof location === "undefined" ? "/" : location.pathname,
) {
  if (typeof location !== "undefined" && pathname === "/")
    return profileIdForHost(location.hostname) ?? null;
  return /^\/a\/([A-Za-z0-9_-]{8,200})\/?$/.exec(pathname)?.[1] ?? null;
}

/** One stored lesson per instructor page, so switching between them never restores the other's. */
export function liveSessionKey(profileId = learnerProfileId()) {
  return profileId ? `liveavatar.live-session:${profileId}` : "liveavatar.live-session";
}
